import { useEffect } from "react";

import { axiosPrivate } from "../../lib/axios";
import { useSelector } from "react-redux";
import { useRefreshToken } from "../../features/Authentication";

function useAxiosPrivate() {
  const { auth } = useSelector((state) => state.authProvider);
  const { refresh, loading } = useRefreshToken();

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${auth?.accessToken}`;
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;

        // console.log(error.response);
        if (error.response.status == 401 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const newAccessToken = await refresh();
          prevRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return axiosPrivate(prevRequest);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.response.eject(responseIntercept);
      axiosPrivate.interceptors.request.eject(requestIntercept);
    };
  }, [refresh, auth]);

  return axiosPrivate;
}

export default useAxiosPrivate;
